(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
'use strict';
var $197cd56b15c33885$var$gameCell = document.querySelectorAll('.field-cell');
var $197cd56b15c33885$var$button = document.querySelector('button');
var $197cd56b15c33885$var$scoreInfo = document.querySelector('.game-score');
var $197cd56b15c33885$var$messageStart = document.querySelector('.message-start');
var $197cd56b15c33885$var$messageWin = document.querySelector('.message-win');
var $197cd56b15c33885$var$messageLose = document.querySelector('.message-lose');
var $197cd56b15c33885$var$message = document.querySelector('.message-container');
var $197cd56b15c33885$var$number = document.querySelector('.game-score-number');
var $197cd56b15c33885$var$score = 0;
var $344b02e633e0f2c2$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


'use strict';
var $ed144705a77f59e6$exports = {};

$parcel$export($ed144705a77f59e6$exports, "Cell", function () { return $ed144705a77f59e6$export$f6f0c3fe4ec306ea; });

var $ed144705a77f59e6$export$f6f0c3fe4ec306ea = function Cell(x, y) {
    "use strict";
    (0, $8713978b2328d32b$export$71511d61b312f219)(this, Cell);
    this.x = x;
    this.y = y;
    this.valueNum = undefined;
};
$ed144705a77f59e6$exports = $ed144705a77f59e6$export$f6f0c3fe4ec306ea;


var $344b02e633e0f2c2$var$ROWS_SIZE = 4;
var $344b02e633e0f2c2$var$COLUMNS_SIZE = 4;
function $344b02e633e0f2c2$var$getRandomNumber() {
    return Math.random() <= 0.9 ? 2 : 4;
}
var $344b02e633e0f2c2$var$Game = /*#__PURE__*/ function() {
    function Game() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = [];
        for(var row = 0; row < $344b02e633e0f2c2$var$ROWS_SIZE; row++)for(var column = 0; column < $344b02e633e0f2c2$var$COLUMNS_SIZE; column++)this.board.push(new $ed144705a77f59e6$exports(row, column));
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getRandomCell",
            value: function getRandomCell() {
                var emptyCells = this.board.filter(function(cell) {
                    return cell.valueNum === undefined;
                });
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                return emptyCells[randomIndex] || undefined;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                var valueCells = this.board.filter(function(cellItem) {
                    return cellItem.valueNum !== undefined;
                });
                return valueCells;
            }
        },
        {
            key: "addNumber",
            value: function addNumber() {
                var cell = this.getRandomCell();
                if (!cell) return;
                cell.valueNum = $344b02e633e0f2c2$var$getRandomNumber();
            }
        },
        {
            key: "updateBoard",
            value: function updateBoard() {
                this.board.forEach(function(cell) {
                    var num = cell.valueNum !== undefined ? cell.valueNum : undefined;
                    var x = cell.x;
                    var y = cell.y;
                    var boardElement = document.getElementById("".concat(x, "-").concat(y));
                    if (num !== undefined) {
                        boardElement.classList.value = '';
                        boardElement.classList.add('field-cell');
                        boardElement.textContent = num;
                        boardElement.classList.add("field-cell--".concat(num));
                        boardElement.classList.toggle('animation-appear');
                    } else {
                        boardElement.textContent = '';
                        boardElement.classList.value = '';
                        boardElement.classList.add('field-cell');
                    }
                });
            }
        },
        {
            key: "getBoardValues",
            value: function getBoardValues() {
                return this.board.map(function(cell) {
                    return cell.valueNum;
                });
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                if (this.getRandomCell()) return false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this, _loop = function() {
                        var cell = _step.value;
                        var right = _this.board.find(function(c) {
                            return c.x === cell.x && c.y === cell.y + 1;
                        });
                        var down = _this.board.find(function(c) {
                            return c.x === cell.x + 1 && c.y === cell.y;
                        });
                        if (right && right.valueNum === cell.valueNum || down && down.valueNum === cell.valueNum) return {
                            v: false
                        };
                    };
                    for(var _iterator = this.board[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = (_this = this, _loop());
                        if ((0, $0b5c99e6a0876eaa$export$71511d61b312f219)(_ret) === "object") return _ret.v;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return true;
            }
        }
    ]);
    return Game;
}();
$344b02e633e0f2c2$exports = $344b02e633e0f2c2$var$Game;


var $197cd56b15c33885$var$game = new $344b02e633e0f2c2$exports();
// Animation after page has loaded
function $197cd56b15c33885$var$loadPageNotification() {
    $197cd56b15c33885$var$button.removeAttribute('disabled');
    $197cd56b15c33885$var$messageStart.style.bottom = '40%';
    var startNotif = new Promise(function(resolve) {
        window.addEventListener('load', function() {
            setTimeout(function() {
                resolve();
            }, 1000);
        });
    });
    startNotif.then(function() {
        $197cd56b15c33885$var$messageStart.style.opacity = '1';
        $197cd56b15c33885$var$messageStart.style.transform = 'scale(1.3)';
        setTimeout(function() {
            var setPositionStartNotif = new Promise(function(resolve) {
                resolve();
            });
            setPositionStartNotif.then(function() {
                $197cd56b15c33885$var$messageStart.style.bottom = '0%';
                $197cd56b15c33885$var$messageStart.style.transform = 'scale(1)';
                return new Promise(function(resolve) {
                    setTimeout(function() {
                        resolve();
                    }, 1000);
                });
            }).then(function() {
                $197cd56b15c33885$var$button.removeAttribute('disabled');
                $197cd56b15c33885$var$button.style.animation = 'button-bloom 1s ease';
            });
        }, 1000);
    });
}
$197cd56b15c33885$var$loadPageNotification();
// Function for identify each cell (Creation id such us '0-1' for each cell)
function $197cd56b15c33885$var$createId() {
    var x = 0;
    var y = 0;
    $197cd56b15c33885$var$gameCell.forEach(function(item) {
        item.id = "".concat(x, "-").concat(y);
        if (y < 3) y++;
        else {
            x++;
            y = 0;
        }
    });
}
$197cd56b15c33885$var$createId();
// Event for button which can represent "Start" or "Restart"
$197cd56b15c33885$var$button.addEventListener('click', function(e) {
    $197cd56b15c33885$var$message.style.opacity = '0'; // Hide all messages under gameboard
    $197cd56b15c33885$var$messageStart.style.opacity = '0';
    // Return location of all messages to initial state
    $197cd56b15c33885$var$messageLose.style.bottom = '0%';
    $197cd56b15c33885$var$messageWin.style.bottom = '0%';
    $197cd56b15c33885$var$messageStart.style.bottom = '0%';
    // Hide all messages under gameboard
    $197cd56b15c33885$var$messageLose.classList.add('hidden');
    $197cd56b15c33885$var$messageWin.classList.add('hidden');
    // Screenplay for activation game and behavior for "Start" botton
    if ($197cd56b15c33885$var$button.classList.contains('start')) {
        $197cd56b15c33885$var$button.textContent = 'Restart';
        $197cd56b15c33885$var$button.classList.remove('start');
        $197cd56b15c33885$var$button.classList.add('restart');
        $197cd56b15c33885$var$game.addNumber();
        $197cd56b15c33885$var$game.addNumber();
        $197cd56b15c33885$var$game.updateBoard();
    // Screenplay for behavior "Start" botton
    } else if ($197cd56b15c33885$var$button.classList.contains('restart')) {
        $197cd56b15c33885$var$game.getValues().forEach(function(cellItem) {
            cellItem.valueNum = undefined;
        });
        $197cd56b15c33885$var$game.updateBoard();
        $197cd56b15c33885$var$button.textContent = 'Start';
        $197cd56b15c33885$var$button.style.width = '100px';
        $197cd56b15c33885$var$button.classList.remove('restart');
        $197cd56b15c33885$var$button.classList.add('start');
        $197cd56b15c33885$var$score = 0;
        $197cd56b15c33885$var$scoreInfo.textContent = '0';
    }
});
// Creation rows from Game class
function $197cd56b15c33885$var$createRows() {
    return $197cd56b15c33885$var$game.board.reduce(function(boardRows, cell) {
        if (!boardRows[cell.x]) boardRows[cell.x] = [];
        boardRows[cell.x].push(cell);
        return boardRows;
    }, []);
}
// Creation columns from Game class
function $197cd56b15c33885$var$createColumns() {
    return $197cd56b15c33885$var$game.board.reduce(function(boardColumns, cell) {
        if (!boardColumns[cell.y]) boardColumns[cell.y] = [];
        boardColumns[cell.y].push(cell);
        return boardColumns;
    }, []);
}
function $197cd56b15c33885$var$handleKeyUp(e) {
    var rows = $197cd56b15c33885$var$createRows();
    var columns = $197cd56b15c33885$var$createColumns();
    var prevBoard = $197cd56b15c33885$var$game.getBoardValues();
    var moveTypes = {
        ArrowLeft: function() {
            return $197cd56b15c33885$var$moveLeft(rows);
        },
        ArrowRight: function() {
            return $197cd56b15c33885$var$moveRight(rows);
        },
        ArrowDown: function() {
            return $197cd56b15c33885$var$moveDown(columns);
        },
        ArrowUp: function() {
            return $197cd56b15c33885$var$moveUp(columns);
        }
    };
    var move = moveTypes[e.code];
    if (!move) return;
    var mergedNum = move();
    var currentBoard = $197cd56b15c33885$var$game.getBoardValues();
    var boardChanged = prevBoard.some(function(val, i) {
        return val !== currentBoard[i];
    });
    if (!boardChanged) return;
    if (mergedNum > 0) {
        $197cd56b15c33885$var$score += mergedNum;
        $197cd56b15c33885$var$setScore(); // Update Score in gameboard
    }
    $197cd56b15c33885$var$game.addNumber();
    $197cd56b15c33885$var$checkGameOver();
    $197cd56b15c33885$var$game.updateBoard(); // Update HTML
}
document.addEventListener('keyup', $197cd56b15c33885$var$handleKeyUp);
// Implementatiom moveup
function $197cd56b15c33885$var$moveUp(columns) {
    var newScore = 0;
    columns.forEach(function(column) {
        var cellVal = column.map(function(cellItem) {
            return cellItem.valueNum;
        }).filter(function(cellItem) {
            return cellItem !== undefined;
        });
        // iteration and check, are there duble numbers
        for(var i = 0; i < cellVal.length - 1; i++)if (cellVal[i] === cellVal[i + 1]) {
            cellVal[i] *= 2; // if yes, duble number
            newScore += cellVal[i]; // increase score variable
            $197cd56b15c33885$var$number.textContent = "+".concat(cellVal[i]); // embed increasing number to 'number' variable, which represent animation over score
            cellVal.splice(i + 1, 1);
        }
        // add objects for achiving initial column length
        while(cellVal.length < column.length)cellVal.push(undefined);
        // replace initials column values to new values
        for(var i1 = 0; i1 < column.length; i1++)column[i1].valueNum = cellVal[i1];
    });
    return newScore;
}
function $197cd56b15c33885$var$moveDown(columns) {
    var newScore = 0;
    columns.forEach(function(column) {
        var cellVal = column.map(function(cellItem) {
            return cellItem.valueNum;
        }).filter(function(cellItem) {
            return cellItem !== undefined;
        });
        // iteration and check, are there duble numbers
        for(var i = cellVal.length - 1; i > 0; i--)if (cellVal[i] === cellVal[i - 1]) {
            cellVal[i] *= 2; // if yes, duble number
            newScore += cellVal[i]; // increase score
            $197cd56b15c33885$var$number.textContent = "+".concat(cellVal[i]); // embed increasing number to 'number' variable, which represent animation over score
            cellVal.splice(i - 1, 1);
        }
        while(cellVal.length < column.length)cellVal.unshift(undefined);
        for(var i1 = 0; i1 < column.length; i1++)column[i1].valueNum = cellVal[i1];
    });
    return newScore;
}
function $197cd56b15c33885$var$moveRight(rows) {
    var newScore = 0;
    rows.forEach(function(row) {
        var cellVal = row.map(function(cellItem) {
            return cellItem.valueNum;
        }).filter(function(cellItem) {
            return cellItem !== undefined;
        });
        for(var i = cellVal.length - 1; i > 0; i--)if (cellVal[i] === cellVal[i - 1]) {
            cellVal[i] *= 2;
            newScore += cellVal[i];
            $197cd56b15c33885$var$number.textContent = "+".concat(cellVal[i]);
            cellVal.splice(i - 1, 1);
        }
        while(cellVal.length < row.length)cellVal.unshift(undefined);
        for(var i1 = 0; i1 < row.length; i1++)row[i1].valueNum = cellVal[i1];
    });
    return newScore;
}
function $197cd56b15c33885$var$moveLeft(rows) {
    var newScore = 0;
    rows.forEach(function(row) {
        var cellVal = row.map(function(cellItem) {
            return cellItem.valueNum;
        }).filter(function(cellItem) {
            return cellItem !== undefined;
        });
        for(var i = 0; i < cellVal.length - 1; i++)if (cellVal[i] === cellVal[i + 1]) {
            cellVal[i] *= 2;
            newScore += cellVal[i];
            $197cd56b15c33885$var$number.textContent = "+".concat(cellVal[i]);
            cellVal.splice(i + 1, 1);
        }
        while(cellVal.length < row.length)cellVal.push(undefined);
        for(var i1 = 0; i1 < row.length; i1++)row[i1].valueNum = cellVal[i1];
    });
    return newScore;
}
// Updation score and implementation victorious screenplay
function $197cd56b15c33885$var$setScore() {
    $197cd56b15c33885$var$scoreInfo.textContent = $197cd56b15c33885$var$score; // Update HTML
    // set animation class for score
    $197cd56b15c33885$var$number.classList.add('animation-number-slide');
    setTimeout(function() {
        $197cd56b15c33885$var$number.classList.remove('animation-number-slide');
    }, 800);
    // implementation victorious screenplay
    var haveVictoriousNum = $197cd56b15c33885$var$game.board.some(function(cell) {
        return cell.valueNum >= 2048;
    });
    if (haveVictoriousNum === true) {
        $197cd56b15c33885$var$message.style.opacity = '1';
        $197cd56b15c33885$var$messageWin.classList.remove('hidden');
        setTimeout(function() {
            $197cd56b15c33885$var$messageWin.style.bottom = '40%';
            $197cd56b15c33885$var$messageWin.style.transform = 'scale(1.3)';
        }, 1000);
        document.removeEventListener('keyup', $197cd56b15c33885$var$handleKeyUp);
    }
}
// implementation losing screenplay
function $197cd56b15c33885$var$checkGameOver() {
    if ($197cd56b15c33885$var$game.isGameOver()) {
        $197cd56b15c33885$var$message.style.opacity = '1';
        $197cd56b15c33885$var$messageLose.classList.remove('hidden');
        $197cd56b15c33885$var$messageLose.textContent = "You lose with ".concat($197cd56b15c33885$var$score, " score");
        setTimeout(function() {
            $197cd56b15c33885$var$messageLose.style.bottom = '40%';
            $197cd56b15c33885$var$messageLose.style.transform = 'scale(1.3)';
        }, 1000);
        document.removeEventListener('keyup', $197cd56b15c33885$var$handleKeyUp);
    }
}

})();
//# sourceMappingURL=portfolio-2048-game.39cb0e01.js.map
